import { render } from "./WarehouseView.vue?vue&type=template&id=0d6b3614"
import script from "./WarehouseView.vue?vue&type=script&lang=js"
export * from "./WarehouseView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/matejp/Desktop/projects/za-gazde/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__